"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SendFormPlugin = void 0;
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const styled_components_1 = __importDefault(require("styled-components"));
const Yup = __importStar(require("yup"));
const core_1 = require("@dnd-kit/core");
const sortable_1 = require("@dnd-kit/sortable");
const utilities_1 = require("@dnd-kit/utilities");
const core_2 = require("@material-ui/core");
const icons_1 = require("@material-ui/icons");
const lab_1 = require("@material-ui/lab");
const core_ui_1 = require("@sierralabs/core-ui");
const forms_ui_1 = require("@sierralabs/forms-ui");
const user_ui_1 = require("@sierralabs/user-ui");
const workflow_core_1 = require("@sierralabs/workflow-core");
const useWorkflowFileUploader_1 = require("../../../hooks/useWorkflowFileUploader");
const SendForm_hooks_1 = require("./SendForm.hooks");
const TaskFormPage_1 = __importDefault(require("./TaskFormPage"));
var SendFormCustomExpiration;
(function (SendFormCustomExpiration) {
    SendFormCustomExpiration["Days"] = "days";
    SendFormCustomExpiration["Weeks"] = "weeks";
    SendFormCustomExpiration["Months"] = "months";
})(SendFormCustomExpiration || (SendFormCustomExpiration = {}));
const StyledConfiguratorDiv = styled_components_1.default.div `
  .MuiFormControlLabel-root {
    width: 100%;
  }
`;
const SendFormConfigurator = props => {
    const { stateNode, onChange } = props;
    const [invoke, setInvoke] = (0, react_1.useState)(props.invoke);
    if (!invoke.data)
        invoke.data = {};
    const data = invoke.data;
    const { formTemplateList, loadingFormTemplates, findFormTemplates } = (0, forms_ui_1.useFindFormTemplates)();
    const { uploader, proxyOptions } = (0, useWorkflowFileUploader_1.useWorkflowFileUploader)();
    const events = stateNode.events || [];
    const selectedEvent = events.find(event => data.eventName && data.eventName === event.name);
    const options = (0, react_1.useMemo)(() => {
        return ((formTemplateList === null || formTemplateList === void 0 ? void 0 : formTemplateList.data) || []).map(formTemplate => {
            return {
                id: formTemplate.id,
                name: formTemplate.name,
                version: formTemplate.version
            };
        });
    }, [formTemplateList]);
    const update = (updatedData = data) => {
        const updatedInvoke = Object.assign(Object.assign({}, invoke), { data: updatedData });
        setInvoke(updatedInvoke);
        onChange === null || onChange === void 0 ? void 0 : onChange(updatedInvoke);
    };
    (0, react_1.useEffect)(() => {
        findFormTemplates();
    }, [findFormTemplates]);
    return (react_1.default.createElement(StyledConfiguratorDiv, null,
        react_1.default.createElement(core_2.RadioGroup, { value: data.external ? 'external' : 'local', onChange: event => {
                data.external = event.target.value === 'external';
                update();
            } },
            react_1.default.createElement(core_2.FormControlLabel, { value: 'local', label: 'Assign User', control: react_1.default.createElement(core_2.Radio, { color: 'primary' }) }),
            react_1.default.createElement(core_2.FormControlLabel, { value: 'external', label: 'Assign External User', control: react_1.default.createElement(core_2.Radio, { color: 'primary' }) })),
        react_1.default.createElement(core_2.FormControlLabel, { label: 'Optional (allow to skip sending forms)', control: react_1.default.createElement(core_2.Checkbox, { color: 'primary', checked: data.optional || false, onChange: (_, checked) => {
                    data.optional = checked;
                    update();
                } }) }),
        react_1.default.createElement(core_2.Box, { my: 1 },
            react_1.default.createElement(lab_1.Autocomplete, { options: events, value: selectedEvent || null, getOptionLabel: option => {
                    const target = (option.transitions || [])
                        .map(transition => (0, workflow_core_1.parseTaskStatus)(transition.target))
                        .join(', ');
                    return `${option.name} (${stateNode.name} -> ${target})`;
                }, onChange: (_, value) => {
                    data.eventName = value === null || value === void 0 ? void 0 : value.name;
                    update();
                }, renderInput: params => (react_1.default.createElement(core_2.TextField, Object.assign({}, params, { fullWidth: true, size: 'small', variant: 'outlined', label: 'Event Transition', placeholder: 'Select Event Transition' }))) }),
            react_1.default.createElement(core_2.FormHelperText, null, "Select the Event to run when submitting the Form")),
        react_1.default.createElement(core_2.Box, { mb: 1 },
            react_1.default.createElement(core_2.Typography, { variant: 'overline' }, "Forms")),
        react_1.default.createElement(SendFormTemplatePicker, { options: options, values: data.formTemplates, loading: loadingFormTemplates, textFieldProps: { size: 'small' }, onChange: formTemplates => {
                data.formTemplates = formTemplates;
                update();
            } }),
        react_1.default.createElement(core_2.Box, { my: 1 },
            react_1.default.createElement(core_2.Typography, { variant: 'overline' }, "Email Configuration")),
        react_1.default.createElement(core_2.Box, { mb: 2 },
            react_1.default.createElement(core_2.TextField, { fullWidth: true, size: 'small', name: 'subject', variant: 'outlined', label: 'Custon Email Subject', placeholder: 'Enter Custom Subject', value: data.subject || '', onChange: event => {
                    data.subject = event.target.value;
                    update();
                } }),
            react_1.default.createElement(core_2.FormHelperText, null,
                "Leave blank to use default subject:",
                ' ',
                react_1.default.createElement("strong", null, "Sierra QMS Form Invitation"))),
        react_1.default.createElement(core_2.FormControlLabel, { label: 'Enable Custom Expiration', control: react_1.default.createElement(core_2.Checkbox, { color: 'primary', checked: data.enableCustomExpiration || false, onChange: (_, checked) => {
                    data.enableCustomExpiration = checked;
                    update();
                } }) }),
        react_1.default.createElement(core_2.Box, { my: 1 },
            data.enableCustomExpiration ? (react_1.default.createElement(core_2.Grid, { container: true, spacing: 1 }, Object.entries(SendFormCustomExpiration).map(([label, property]) => {
                var _a, _b;
                return (react_1.default.createElement(core_2.Grid, { key: property, item: true, xs: 12, md: 4 },
                    react_1.default.createElement(core_2.TextField, { fullWidth: true, 
                        // use `type=text` with `inputMode=numeric` instead of `type=number`
                        // to avoid issues where onChange isn't called for invalid inputs
                        // NOTE: taken from https://github.com/facebook/react/issues/16554#issuecomment-3194033092
                        type: 'text', inputMode: 'numeric', size: 'small', name: property, variant: 'outlined', label: label, value: (_b = (_a = data.customExpiration) === null || _a === void 0 ? void 0 : _a[property]) !== null && _b !== void 0 ? _b : '', onChange: event => {
                            let value = event.target.value !== ''
                                ? parseInt(event.target.value)
                                : undefined;
                            if (value !== undefined &&
                                (!isFinite(value) || value < 0)) {
                                value = 0;
                            }
                            if (!data.customExpiration)
                                data.customExpiration = {};
                            data.customExpiration[property] = value;
                            update();
                        } })));
            }))) : (react_1.default.createElement(core_2.TextField, { select: true, fullWidth: true, size: 'small', name: 'expiration', variant: 'outlined', label: 'Email Form Link Expiration', value: data.expiration || '2w', onChange: event => {
                    // make sure value is part of options
                    const { value } = event.target;
                    const option = workflow_core_1.SendFormExpirationOptions.find(option => option.value === value);
                    data.expiration = (option === null || option === void 0 ? void 0 : option.value) || '2w';
                    update();
                } }, workflow_core_1.SendFormExpirationOptions.map(option => (react_1.default.createElement(core_2.MenuItem, { key: option.value, value: option.value }, option.label))))),
            react_1.default.createElement(core_2.FormHelperText, null, "Determines the expiration of the Email Form link")),
        react_1.default.createElement(core_2.Box, { my: 1 },
            react_1.default.createElement(core_2.Typography, { variant: 'overline' }, "Custom Message")),
        react_1.default.createElement(core_ui_1.InputHtml, { uploader: uploader, proxyOptions: proxyOptions, value: data.message || '', attachments: data.attachments, helperText: 'Enter Email Custom Message', onChange: value => {
                data.message = value;
                update();
            }, onChangeAttachments: attachments => {
                // remove unused signedUrl
                data.attachments = attachments.map(attachment => {
                    attachment = Object.assign({}, attachment);
                    delete attachment.signedUrl;
                    return attachment;
                });
                update();
            } }),
        react_1.default.createElement(core_2.FormControlLabel, { label: 'Allow Overriding Custom Message', control: react_1.default.createElement(core_2.Checkbox, { color: 'primary', checked: data.enableOverrideMessage || false, onChange: (_, checked) => {
                    data.enableOverrideMessage = checked;
                    update();
                } }) })));
};
const SendFormDisplay = () => null;
const SendFormDialog = props => {
    const { open, data, state, onSend } = props;
    const onSendRef = (0, react_1.useRef)(onSend);
    onSendRef.current = onSend;
    const [skip, setSkip] = (0, react_1.useState)(false);
    const [user, setUser] = (0, react_1.useState)(() => {
        return { formTemplates: data.formTemplates };
    });
    const [message, setMessage] = (0, react_1.useState)({ override: false, value: data.message });
    const { task } = state.context;
    const { emails, isLoading, error, sendForm } = (0, SendForm_hooks_1.useSendForm)(task.id);
    const { formTemplateList, loadingFormTemplates, findFormTemplates } = (0, forms_ui_1.useFindFormTemplates)();
    const noFormTemplates = (user.formTemplates || []).length === 0;
    const isValidEmail = (0, react_1.useMemo)(() => {
        return user.email && Yup.string().email().isValidSync(user.email);
    }, [user]);
    const errorEmail = data.external && !!user.email && !isValidEmail;
    const allFormTemplates = (0, react_1.useMemo)(() => {
        const formTemplates = (formTemplateList === null || formTemplateList === void 0 ? void 0 : formTemplateList.data) || [];
        return (data.formTemplates || []).map(formTemplate => {
            // use proper name if available
            const loadedTemplate = formTemplates.find(template => template.id === formTemplate.id);
            return {
                id: formTemplate.id,
                version: formTemplate.version,
                name: (loadedTemplate === null || loadedTemplate === void 0 ? void 0 : loadedTemplate.name) || formTemplate.name
            };
        });
    }, [data.formTemplates, formTemplateList]);
    const onCancel = () => {
        var _a;
        if (!isLoading) {
            (_a = props.onCancel) === null || _a === void 0 ? void 0 : _a.call(props);
        }
    };
    (0, react_1.useEffect)(() => {
        findFormTemplates();
    }, [findFormTemplates]);
    (0, react_1.useEffect)(() => {
        var _a;
        if (emails) {
            (_a = onSendRef.current) === null || _a === void 0 ? void 0 : _a.call(onSendRef, emails);
        }
    }, [emails]);
    return (react_1.default.createElement(core_2.Dialog, { fullWidth: true, maxWidth: 'sm', open: open, onClose: onCancel },
        (isLoading || loadingFormTemplates) && react_1.default.createElement(core_2.LinearProgress, null),
        react_1.default.createElement(core_2.DialogTitle, null, "Send Form"),
        react_1.default.createElement(core_2.DialogContent, null,
            react_1.default.createElement(core_2.DialogContentText, null, "Please enter recipient details"),
            react_1.default.createElement(core_2.Box, { mb: 1 },
                react_1.default.createElement(core_2.Typography, { variant: 'overline' },
                    "Assign ",
                    data.external && 'External ',
                    "User")),
            react_1.default.createElement(core_2.Grid, { container: true, spacing: 2 },
                !data.external && (react_1.default.createElement(core_2.Grid, { item: true, xs: 12 },
                    react_1.default.createElement(user_ui_1.UserPicker, { showEmail: true, value: user.id, multiple: false, textFieldProps: { autoFocus: true }, onChange: value => {
                            setUser(user => {
                                if (!value) {
                                    user = Object.assign({}, user);
                                    delete user.id;
                                    delete user.email;
                                    delete user.firstName;
                                    delete user.lastName;
                                    return user;
                                }
                                return Object.assign(Object.assign({}, user), { id: value.id, email: value.email, firstName: value.firstName, lastName: value.lastName });
                            });
                        } }))),
                data.external && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(core_2.Grid, { item: true, xs: 12 },
                        react_1.default.createElement(core_2.Grid, { container: true, spacing: 2 },
                            react_1.default.createElement(core_2.Grid, { item: true, xs: 6 },
                                react_1.default.createElement(core_2.TextField, { autoFocus: true, fullWidth: true, name: 'firstName', label: 'First Name', variant: 'outlined', placeholder: 'Enter First Name', value: user.firstName || '', onChange: event => {
                                        setUser(user => {
                                            return Object.assign(Object.assign({}, user), { firstName: event.target.value });
                                        });
                                    } })),
                            react_1.default.createElement(core_2.Grid, { item: true, xs: 6 },
                                react_1.default.createElement(core_2.TextField, { fullWidth: true, name: 'lastName', label: 'Last Name', variant: 'outlined', placeholder: 'Enter Last Name', value: user.lastName || '', onChange: event => {
                                        setUser(user => {
                                            return Object.assign(Object.assign({}, user), { lastName: event.target.value });
                                        });
                                    } })))),
                    react_1.default.createElement(core_2.Grid, { item: true, xs: 12 },
                        react_1.default.createElement(core_2.TextField, { fullWidth: true, type: 'email', name: 'email', label: 'Email', variant: 'outlined', placeholder: 'Enter Email', value: user.email || '', error: errorEmail, helperText: errorEmail ? 'Should be a valid email address.' : undefined, onChange: event => {
                                setUser(user => {
                                    return Object.assign(Object.assign({}, user), { email: event.target.value });
                                });
                            } })))),
                react_1.default.createElement(core_2.Grid, { item: true, xs: 12 },
                    react_1.default.createElement(SendFormTemplatePicker, { options: allFormTemplates, values: user.formTemplates, textFieldProps: {
                            error: noFormTemplates,
                            helperText: noFormTemplates && 'Form Templates are required.'
                        }, onChange: formTemplates => {
                            setUser(user => (Object.assign(Object.assign({}, user), { formTemplates })));
                        } }))),
            data.enableOverrideMessage && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(core_2.Box, { mt: 1 },
                    react_1.default.createElement(core_2.Typography, { variant: 'overline' }, "Email")),
                react_1.default.createElement(core_2.FormControlLabel, { disabled: isLoading, label: 'Override Custom Message', control: react_1.default.createElement(core_2.Checkbox, { color: 'primary', checked: message.override, onChange: () => {
                            setMessage(message => {
                                return Object.assign(Object.assign({}, message), { override: !message.override });
                            });
                        } }) }))),
            data.enableOverrideMessage && message.override && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(core_ui_1.InputHtml, { disabled: isLoading, value: message.value || '', helperText: 'Enter Custom Message', onChange: value => {
                        setMessage(message => (Object.assign(Object.assign({}, message), { value })));
                    } }),
                react_1.default.createElement(core_2.Box, { mt: 1 },
                    react_1.default.createElement(core_2.Button, { variant: 'outlined', disabled: isLoading, onClick: () => {
                            setMessage(message => (Object.assign(Object.assign({}, message), { value: data.message })));
                        } }, "Reset Message")))),
            react_1.default.createElement(core_2.Collapse, { in: !!error, style: { minHeight: 'unset' } },
                react_1.default.createElement(core_2.Box, { mt: 1, mx: 3 },
                    react_1.default.createElement(lab_1.Alert, { severity: 'error' }, (error === null || error === void 0 ? void 0 : error.message) || 'An error occurred.')))),
        react_1.default.createElement(core_2.DialogActions, null,
            data.optional && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(core_2.Button, { color: 'primary', variant: 'outlined', disabled: isLoading, onClick: () => setSkip(true) }, "Skip Action"),
                react_1.default.createElement("div", { style: { flex: 1 } }))),
            react_1.default.createElement(core_2.Button, { disabled: isLoading, onClick: onCancel }, "Cancel"),
            react_1.default.createElement(core_2.Button, { color: 'primary', variant: 'contained', disabled: isLoading || !isValidEmail || noFormTemplates, onClick: () => {
                    const dto = { user: Object.assign({}, user), path: state.path };
                    // only include custom message if it is different from the default value
                    if (message.override && message.value !== data.message) {
                        dto.overrideMessage = message.value;
                    }
                    // remove formTemplates if they are the same as configured templates
                    // also handle check for different order of formTemplates
                    const isEqual = allFormTemplates.every((formTemplate, index) => {
                        var _a;
                        const template = (_a = dto.user.formTemplates) === null || _a === void 0 ? void 0 : _a[index];
                        return (template &&
                            formTemplate.id === template.id &&
                            formTemplate.version === template.version);
                    });
                    if (isEqual) {
                        delete dto.user.formTemplates;
                    }
                    sendForm(dto);
                } }, "Send Form")),
        react_1.default.createElement(core_ui_1.ConfirmDialog, { open: skip, title: 'Skip Send Form', message: 'Are you sure you do not want to send any forms? ' +
                'This will skip this action and continue to transition the item.', confirmLabel: 'Confirm Skip Action', onCancel: () => setSkip(false), onConfirm: () => {
                setSkip(false);
                onSend === null || onSend === void 0 ? void 0 : onSend([]);
            } })));
};
const StyledList = (0, styled_components_1.default)(core_2.List) `
  margin-top: 8px;
  border-radius: 4px;
  border: 1px solid ${props => props.theme.palette.divider};
  &.hidden {
    display: none;
  }
`;
const SendFormTemplatePicker = props => {
    const { values, options, loading, textFieldProps, onChange } = props;
    const dragChangeRef = (0, react_1.useRef)({ sourceIndex: -1, targetIndex: -1 });
    const [dragId, setDragId] = (0, react_1.useState)();
    const [selected, setSelected] = (0, react_1.useState)();
    const formTemplates = values || [];
    const sort = (0, core_ui_1.useSort)(formTemplates, item => item.id.toString());
    const sensors = (0, core_1.useSensors)((0, core_1.useSensor)(core_1.PointerSensor));
    const hasSelected = formTemplates.length > 0;
    const dragItem = (0, react_1.useMemo)(() => {
        return values === null || values === void 0 ? void 0 : values.find(formTemplate => formTemplate.id === dragId);
    }, [dragId, values]);
    // hide selected items from dropdown
    const filteredOptions = (0, react_1.useMemo)(() => {
        return values
            ? options.filter(option => !values.some(value => value.id === option.id))
            : options;
    }, [options, values]);
    const clearDragChange = () => {
        dragChangeRef.current.sourceIndex = -1;
        dragChangeRef.current.targetIndex = -1;
    };
    // clear field on select
    (0, react_1.useEffect)(() => {
        selected && setSelected(undefined);
    }, [selected]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(lab_1.Autocomplete, { fullWidth: true, clearOnBlur: true, clearOnEscape: true, loading: loading, value: selected || null, options: filteredOptions, getOptionLabel: option => option.name || '', getOptionSelected: (option, value) => {
                return option.id === value.id && option.version === value.version;
            }, onChange: (_, value) => {
                setSelected(value || undefined);
                if (value &&
                    !formTemplates.some(formTemplate => formTemplate.id === value.id)) {
                    onChange === null || onChange === void 0 ? void 0 : onChange(formTemplates.concat(value));
                }
            }, renderInput: params => (react_1.default.createElement(core_2.TextField, Object.assign({}, params, { fullWidth: true, variant: 'outlined', label: 'Select Form Templates', placeholder: 'Select and order Form Templates' }, textFieldProps))) }),
        react_1.default.createElement(StyledList, { dense: true, disablePadding: true, className: hasSelected ? undefined : 'hidden' },
            react_1.default.createElement(core_1.DndContext, { sensors: sensors, onDragStart: event => {
                    var _a;
                    // prevent dragging if currently dragging an item
                    if (dragId) {
                        return;
                    }
                    const index = formTemplates.findIndex(formTemplate => formTemplate.id.toString() === event.active.id);
                    dragChangeRef.current.sourceIndex = index;
                    setDragId((_a = formTemplates[index]) === null || _a === void 0 ? void 0 : _a.id);
                }, onDragOver: event => {
                    const { active, over } = event;
                    if (over && active.id !== over.id) {
                        dragChangeRef.current.targetIndex = sort.findIndex(over.id);
                        sort.reorder(active.id, over.id);
                    }
                }, onDragEnd: () => {
                    const { sourceIndex, targetIndex } = dragChangeRef.current;
                    if (sourceIndex > -1 &&
                        targetIndex > -1 &&
                        sourceIndex !== targetIndex) {
                        const values = (0, sortable_1.arrayMove)(formTemplates, sourceIndex, targetIndex);
                        onChange === null || onChange === void 0 ? void 0 : onChange(values);
                    }
                    clearDragChange();
                    setDragId(undefined);
                }, onDragCancel: () => {
                    clearDragChange();
                    setDragId(undefined);
                } },
                react_1.default.createElement(sortable_1.SortableContext, { strategy: sortable_1.verticalListSortingStrategy, items: sort.items.map(item => item.id.toString()) }, sort.items.map((item, index) => (react_1.default.createElement(SortableFormItem, { item: item, key: `${item.id}-${index}`, onRemove: () => {
                        const values = formTemplates.filter(formTemplate => formTemplate.id !== item.id);
                        onChange === null || onChange === void 0 ? void 0 : onChange(values);
                    } })))),
                react_1.default.createElement(core_1.DragOverlay, null, dragItem && react_1.default.createElement(FormItem, { isDragging: true, item: dragItem }))))));
};
const StyledListItem = (0, styled_components_1.default)(core_2.ListItem) `
  padding: 8px;
  &:not(:first-child) {
    border-top: 1px solid ${props => props.theme.palette.divider};
  }
  &.dragging {
    opacity: 0.8;
    background: #fff;
    border-radius: 2px;
    box-shadow: ${props => props.theme.shadows[2]};
  }
  .drag-handle {
    cursor: grab;
    margin-top: 6px;
    transition: color 300ms cubic-bezier(0.075, 0.82, 0.165, 1);
    &:not(:hover) {
      color: ${props => props.theme.palette.action.disabled};
    }
  }
`;
const FormItem = props => {
    const { item, isDragging, listItemProps, dragHandleProps, onRemove } = props;
    return (react_1.default.createElement(StyledListItem, Object.assign({}, listItemProps, { className: isDragging ? 'dragging' : undefined }),
        react_1.default.createElement(core_2.ListItemIcon, Object.assign({}, dragHandleProps, { className: 'drag-handle' }),
            react_1.default.createElement(icons_1.DragIndicator, { fontSize: 'small' })),
        react_1.default.createElement(core_2.ListItemText, null, item.name),
        react_1.default.createElement(core_2.ListItemIcon, null,
            react_1.default.createElement(core_2.IconButton, { size: 'small', onClick: onRemove },
                react_1.default.createElement(icons_1.Close, { fontSize: 'small' })))));
};
const SortableFormItem = props => {
    const { item, isDragging } = props;
    const { attributes, listeners, setNodeRef, transform, transition } = (0, sortable_1.useSortable)({ id: item.id.toString() });
    return (react_1.default.createElement(FormItem, Object.assign({}, props, { dragHandleProps: Object.assign(Object.assign({}, attributes), listeners), listItemProps: {
            ref: setNodeRef,
            style: {
                opacity: isDragging ? 0.75 : undefined,
                transform: utilities_1.CSS.Translate.toString(transform),
                transition: transition || undefined
            }
        } })));
};
const SendFormPluginRoutes = () => {
    return react_1.default.createElement(react_router_dom_1.Route, { path: '/forms/task', component: TaskFormPage_1.default });
};
exports.SendFormPlugin = {
    src: 'sendForm',
    name: 'Send Form',
    configurator: SendFormConfigurator,
    display: SendFormDisplay,
    routes: SendFormPluginRoutes,
    validate: condition => {
        const data = condition.data;
        return !!(data &&
            data.eventName &&
            Array.isArray(data.formTemplates) &&
            data.formTemplates.length > 0);
    },
    service: (state, params, render) => {
        if (!render) {
            return false;
        }
        console.log('sendForm params', params);
        const pluginParams = Array.isArray(params) ? params[0] : params;
        return new Promise((resolve, reject) => {
            render(react_1.default.createElement(SendFormDialog, { open: true, state: state, data: pluginParams.data, onCancel: () => {
                    render(undefined);
                    reject();
                }, onSend: () => {
                    render(undefined);
                    resolve(true);
                } }));
        });
    }
};
//# sourceMappingURL=SendFormPlugin.js.map